import React, { Component } from "react";
import Banner from "../../../components/common/Banner";
import Header from "../../../components/common/Header";
import DepartmentSidebar from "../component/DepartmentSidebar";
import DepartmentAchievers from "../component/DepartmentAchievers";
import DepartmentNumbers from "../component/DepartmentNumbers";
import Footer from "../../../components/common/Footer";
import DepartmentVideo from "../component/DepartmentVideo";

export default class DataScienceAbout extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner
          title="Computer Science & Engineering (Data Science)"
          image="banners/department-cse.jpg"
        />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <DepartmentAchievers department="datascience" />
                  <DepartmentNumbers
                    text1="Number of students on roll"
                    num1="194"
                    text2="Number of Faculty"
                    num2="5"
                    text3="Number of Faculty with Ph.D"
                    num3="1"
                    text4="Number of Technical Staff"
                    num4="4"
                    text5="Number of Faculties Pursuing Ph.D"
                    num5="4"
                    text6="Number of Patents"
                    num6="3"
                    text7="Number of Publications"
                    num7="42"
                  />
                  <div className="ttm-service-description">
                    <div className="row">
                      <div className="col-md-5">
                        <div className="ttm_single_image-wrapper">
                          <img
                            className="img-fluid"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/departments/datascience/datascience.jpeg"
                            }
                            alt="single-img-eighteen"
                          />
                        </div>
                      </div>
                      <div
                        className="col-md-7 justify"
                        style={{ margin: "auto" }}
                      >
                        <p>
                          The department of CSE (Data Science) was established
                          in the year 2022. The department aims at building
                          graduates to be skilled Data Scientists. The program
                          emphasizes core Data Science courses integrated with
                          the multidisciplinary computational mathematics,
                          statistics, management and computer science courses.
                          BIT with its expertise in multi-disciplinary science,
                          is best positioned to offer the programme for students
                          who are willing to gain an in-depth understanding of
                          the technicalities of working wit data and identifying
                          insights. 
                        </p>
                      </div>
                      <div className="col-md-12 paddingtop-2 justify">
                        <p>
                          Data engineering involves data collection methods,
                          designing enterprise data storage and retrieval. The
                          program focuses on data analytics, visualization,
                          predictive modeling and analytics for data-driven
                          decision making, machine learning, knowledge
                          representation, artificial intelligence and deep
                          learning with relevant case studies.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Department Video</h4>
                    </div>
                    <iframe
                      title="1"
                      src="https://www.youtube.com/embed/5icyleJmE_k"
                      frameBorder="0"
                      allow="autoplay; fullscreen"
                      allowFullScreen
                      width="560"
                      height="315"
                    />
                  </div>
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Vision</h4>
                    </div>
                    <p>
                      To establish a state of art academic department that
                      trains the next generation students as Data Scientists who
                      will solve complex challenges through innovation and
                      world-class research.
                    </p>
                  </div>
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Mission</h4>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon justify">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To provide an environment for leading edge research
                          that has a strong and rapid impact on the economy.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To establish a “Center of Excellence" to facilitate
                          Data creators, providers, managers, curators, and
                          users.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To inculcate the strong qualities of leadership and
                          Entrepreneurship.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="section-title with-desc text-left clearfix">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">
                        Program Educational Objectives (PEO's)
                      </h4>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To provide graduates with both fundamental and
                          advanced concepts of computer science and engineering
                          for acquiring knowledge.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To prepare the graduates to apply computer engineering
                          knowledge to build professional career.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To enable students to engage in lifelong learning with
                          the ability to involve in higher studies and research.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          To encourage graduates to imbibe professional ethics
                          and soft skills.
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="ttm-service-single-content-area paddingtop-2">
                    <div className="section-title with-desc text-left clearfix">
                      <div
                        className="title-header"
                        style={{ borderTopColor: "red" }}
                      >
                        <h4 className="title">Program Outcomes</h4>
                      </div>
                    </div>
                    <div className="ttm-service-description">
                      <ul className="ttm-list ttm-list-style-icon">
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Engineering knowledge : Apply the knowledge of
                            mathematics, science, engineering fundamentals, and
                            an engineering specialization to the solution of
                            complex engineering problems.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Problem analysis : Identify, formulate, review
                            research literature, and analyze complex
                            nengineering problems reaching substantiated
                            conclusions using first principles of mathematics,
                            natural sciences, and engineering sciences.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Design/development of solutions : Design solutions
                            for complex engineering problems and design system
                            components or processes that meet the specified
                            needs with appropriate consideration for the public
                            health and safety, and the cultural, societal, and
                            environmental considerations.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Conduct investigations of complex problems : Use
                            research-based knowledge and research methods
                            including design of experiments, analysis and
                            interpretation of data, and synthesis of the
                            information to provide valid conclusions.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Modern tool usage : Create, select, and apply
                            appropriate techniques, resources, and modern
                            engineering and IT tools including prediction and
                            modelling to complex engineering activities with an
                            understanding of the limitations.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            The engineer and society : Apply reasoning informed
                            by the contextual knowledge to assess societal,
                            health, safety, legal and cultural issues and the
                            consequent responsibilities relevant to the
                            professional engineering practice.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Environment and sustainability : Understand the
                            impact of the professional engineering solutions in
                            societal and environmental contexts, and demonstrate
                            the knowledge of, and need for sustainable
                            development.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Ethics : Apply ethical principles and commit
                            toprofessional ethics and responsibilities andnorms
                            of the engineering practice.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Individual and team work : Function effectively as
                            an individual, and as a member or leader in diverse
                            teams, and in multidisciplinary settings.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Communication : Communicate effectively on complex
                            engineering activities with the engineering
                            community and with society at large, such as, being
                            able to comprehend and write effective reports and
                            design documentation, make effective presentations,
                            and give and receive clear instructions.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Project management and finance : Demonstrate
                            knowledge and understanding of the engineering and
                            management principles and apply these to one’s own
                            work, as a member and leader in a team, to manage
                            projects and in multidisciplinary environments.
                          </span>
                        </li>
                        <li>
                          <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                          <span className="ttm-list-li-content">
                            Life-long learning : Recognize the need for, and
                            have the preparation and ability to engage in
                            independent and life-long learning in the broadest
                            context of technological change.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header paddingtop-2"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Program Specific Outcomes</h4>
                    </div>
                    <ul className="ttm-list ttm-list-style-icon">
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          The graduates of the program will have the ability to
                          apply modern artificial intelligence and deep learning
                          methods to complex prediction & recognition tasks.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          The graduates of the program will play an analytical
                          role in a company where one can design, implement, and
                          evaluate advanced statistical models and approaches
                          for application to the company’s most complex problem.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DepartmentSidebar department="datascience" />
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
